import React, { Component } from 'react';
import { Table } from 'react-bootstrap';

class SearchTable extends Component {

    render() {
        return (
            <Table striped bordered hover responsive style={{marginTop: '10px'}}>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Departments</th>
                        <th>Impact Area of Concentration</th>
                        <th>Type of Experience</th>
                        <th>Major/Area</th>
                        <th>Experiences</th>
                        <th>Contacts</th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.items.map(function (item) {
                        return <tr key={item.name}>
                            <td>{item.name}</td>
                            <td>{item.description}</td>
                            <td>{item.departments.map(function (listItem) {
                                return <div>{listItem}<br /></div>
                            })}</td>
                            <td>{item.impacts.map(function (listItem) {
                                return <div>{listItem}<br /></div>
                            })}</td>
                            <td>{item.employments.map(function (listItem) {
                                return <div>{listItem}<br /></div>
                            })}</td>
                            <td>{item.majors.map(function (listItem) {
                                return <div>{listItem}<br /></div>
                            })}
                            </td>
                            <td>{item.eTag}</td>
                            <td>{item.contacts.map(function (listItem) {
                                return <a href={listItem}>{listItem}<br /></a>
                            })}</td>
                        </tr>
                    })}
                </tbody>
            </Table>
        )
    }
}

export default SearchTable;



// WEBPACK FOOTER //
// ./src/components/Search/SearchTable.js